import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { patchNote, postSummary } from "../../../../services/httpClient";
import Contact from "./Contact";
import Intervention from "./Intervention";
import Referral from "./Referral";
import Standard from "./Standard";
import StudentConnections from "./StudentConnections";
import useApp from "../../../../utils/useApp";
import { User } from "../../../../types/user";
import Infraction from "./Infraction";
import Intake from "./Intake";
import Exit from "./Exit";
import CustomNote from "./CustomNote";

interface EditNoteState {
  fetchNotes: any;
  note: any;
  noteType: any;
  family: User[];
  activeFamily: User[];
  setViewNotes: any;
  setEditNote: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  saveIsEnabled: boolean;
  setSaveIsEnabled: any;
  setUserToSave: any;
  setSummary: any;
  myCase: boolean;
  setIsLoading: any;
}

const EditNote = ({
  fetchNotes,
  note,
  noteType,
  family,
  activeFamily,
  setViewNotes,
  setEditNote,
  setShowToast,
  setToastText,
  setToastBody,
  saveIsEnabled,
  setSaveIsEnabled,
  setUserToSave,
  setSummary,
  myCase,
  setIsLoading,
}: EditNoteState) => {
  const { id } = useParams();
  const { showMenu }: any = useApp();
  const [updatedNote, setUpdatedNote] = useState<any>({});
  const [docs, setDocs] = useState<any[]>([]);
  const [familyUser, setFamilyUser] = useState<string>("unassigned");
  const [isBanned, setIsBanned] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [isSelectedDisabled, setIsSelectedDisabled] = useState<boolean>(false);

  const [errMsg, setErrMsg] = useState<string>("");

  const onClickSave = () => {
    setErrMsg("");

    patchNote(updatedNote, id, note?.id)
      .then(async (res: any) => {
        setIsLoading(true);

        postSummary(id)
          .then((res: any) => {
            var magic = res[0].data?.summary?.postResponse;
            setSummary(magic);
          })
          .catch((err: any) => {
            console.log(err);
          });

        setSaveIsEnabled(false);
        setUserToSave(false);
        setViewNotes(true);
        setEditNote(false);
        setShowToast(true);
        setToastText("Note Updated");
        setToastBody(note?.notetypename);
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg);
      })
      .finally(() => {
        fetchNotes();
      });
  };

  useEffect(() => {
    console.log(note);
    if (note) {
      const deleted: boolean = family?.find((f) => f.id === note?.subject?.id && f.type === note?.subject?.type)?.isDeleted ?? false;
      setIsDeleted(deleted);
      const banned: boolean = family?.find((f) => f.id === note?.subject?.id && f.type === note?.subject?.type)?.isBanned ?? false;
      setIsBanned(banned);
      setIsSelectedDisabled(!myCase || deleted || banned);

      if (deleted) {
        setFamilyUser(note?.subject?.id + "|" + note?.subject?.type + "|" + note.subject.name + " - Deleted");
      } else if (banned) {
        setFamilyUser(note?.subject?.id + "|" + note?.subject?.type + "|" + note.subject.name + " - Banned");
      } else {
        setFamilyUser(note?.subject?.id + "|" + note?.subject?.type);
      }
    }
  }, [note]);

  return (
    <>
      <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
        {errMsg}
      </p>
      <Card className={showMenu ? "bg-light sticky-top card-note-menu-open-sticky" : "bg-light sticky-top card-note-sticky"}>
        <Row className="pe-0 mb-3 mt-3">
          <Col className="col-6 d-flex align-items-center">
            <h5 className="app-orange-text mb-0">{note?.notetypename}</h5>
          </Col>
          <Col className="col-4"></Col>
          <Col className="col-2 d-flex justify-content-end align-items-center">
            {myCase && (
              <Button className="app-secondary-color button" onClick={() => onClickSave()} disabled={!saveIsEnabled}>
                Save
              </Button>
            )}
          </Col>
        </Row>
      </Card>

      {note?.notetype === "standard" ? (
        <Standard
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          documents={docs}
          setDocuments={setDocs}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
          setShowToast={setShowToast}
          setToastText={setToastText}
          setToastBody={setToastBody}
        />
      ) : note?.notetype === "contact" ? (
        <Contact
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "intervention" ? (
        <Intervention
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "referral" ? (
        <Referral
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "student" ? (
        <StudentConnections
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "infraction" ? (
        <Infraction
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          noteType={noteType}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "intake" ? (
        <Intake
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : note?.notetype === "exit" ? (
        <Exit
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      ) : (
        <CustomNote
          note={note}
          activeFamily={activeFamily}
          familyUser={familyUser}
          setFamilyUser={setFamilyUser}
          isBanned={isBanned}
          isDeleted={isDeleted}
          isSelectedDisabled={isSelectedDisabled}
          setUpdatedNote={setUpdatedNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={myCase}
          editNote={true}
        />
      )}
    </>
  );
};

export default EditNote;
